var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2265_15233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 10.5C21.9962 10.5 22.5154 11.6503 21.9157 12.3935L21.8271 12.4915L14.8271 19.4915C14.6262 19.6924 14.3589 19.813 14.0754 19.8309C13.7918 19.8487 13.5115 19.7625 13.2871 19.5883L13.1774 19.4915L6.17739 12.4915L6.08056 12.3818L6.01756 12.292L5.95456 12.18L5.93472 12.138L5.90322 12.0598L5.86589 11.9338L5.85422 11.872L5.84256 11.802L5.83789 11.7355V11.5978L5.84372 11.5302L5.85422 11.4602L5.86589 11.3995L5.90322 11.2735L5.93472 11.1953L6.01639 11.0413L6.09222 10.9363L6.17739 10.8418L6.28706 10.745L6.37689 10.682L6.48889 10.619L6.53089 10.5992L6.60906 10.5677L6.73506 10.5303L6.79689 10.5187L6.86689 10.507L6.93339 10.5023L21.0022 10.5Z",
    fill: "#515151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2265_15233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown31);
export default __webpack_public_path__ + "static/media/Down31.f0a1749ad1085383807fc785ff2661f1.svg";
export { ForwardRef as ReactComponent };